"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePunchCorrectionStatus = void 0;
const PunchCorrectionStatusTypes_1 = require("../PunchCorrectionStatusTypes");
const luxon_1 = require("luxon");
const react_1 = require("react");
function usePunchCorrectionStatus({ punchCorrStatusList }) {
    const [clickedId, setClickedId] = (0, react_1.useState)(null);
    const [isShowMore, setIsShowMore] = (0, react_1.useState)(false);
    const isInDetailsView = clickedId !== null;
    const sortedPunchCorrList = sortList(filterList(punchCorrStatusList));
    const clickedItem = clickedId
        ? sortedPunchCorrList.find((item) => item.requestId === clickedId)
        : null;
    return {
        isInDetailsView,
        isShowMore,
        setIsShowMore,
        clickedItem,
        setClickedId,
        sortedPunchCorrList
    };
}
exports.usePunchCorrectionStatus = usePunchCorrectionStatus;
const filterList = (list) => {
    const filteredMap = list.reduce((filteredList, item) => {
        if (!filteredList.has(item.requestId)) {
            filteredList.set(item.requestId, item);
            return filteredList;
        }
        const savedRequest = filteredList.get(item.requestId);
        if (luxon_1.DateTime.fromISO(savedRequest.updateTime) <
            luxon_1.DateTime.fromISO(item.updateTime)) {
            filteredList.set(item.requestId, item);
        }
        return filteredList;
    }, new Map());
    return Array.from(filteredMap.values());
};
const sortList = (list) => {
    const temp = [...list];
    const sortedList = temp.sort((a, b) => {
        const requestTypeWeight = {
            [PunchCorrectionStatusTypes_1.PunchCorrType.MISSED_PUNCH]: 1,
            [PunchCorrectionStatusTypes_1.PunchCorrType.EDIT_PUNCH]: 2,
            [PunchCorrectionStatusTypes_1.PunchCorrType.DELETE_PUNCH]: 3
        };
        const dateTimeComparator = (a, b) => {
            if (luxon_1.DateTime.fromISO(a.punchDateTime) === luxon_1.DateTime.fromISO(b.punchDateTime)) {
                return 0;
            }
            if (luxon_1.DateTime.fromISO(a.punchDateTime) > luxon_1.DateTime.fromISO(b.punchDateTime)) {
                return -1;
            }
            return 1;
        };
        if (a.requestType === b.requestType) {
            return dateTimeComparator(a, b);
        }
        return requestTypeWeight[a.requestType] - requestTypeWeight[b.requestType];
    });
    const successList = sortedList.filter((item) => [
        PunchCorrectionStatusTypes_1.PunchCorrStatus.COMPLETED_SUCCESSFULLY,
        PunchCorrectionStatusTypes_1.PunchCorrStatus.SUBMITTED_SUCCESSFULLY
    ].includes(item.status));
    const failedList = sortedList.filter((item) => {
        if (item.requestType === PunchCorrectionStatusTypes_1.PunchCorrType.DELETE_PUNCH) {
            return item.status === PunchCorrectionStatusTypes_1.PunchCorrStatus.FAILED;
        }
        if (item.requestType === PunchCorrectionStatusTypes_1.PunchCorrType.MISSED_PUNCH ||
            item.requestType === PunchCorrectionStatusTypes_1.PunchCorrType.EDIT_PUNCH) {
            return (item.status === PunchCorrectionStatusTypes_1.PunchCorrStatus.FAILED &&
                item.reasonCode !== PunchCorrectionStatusTypes_1.PunchCorrReason.DUPLICATE);
        }
        return false;
    });
    const pendingList = sortedList.filter((item) => {
        const pendingStatus = [
            PunchCorrectionStatusTypes_1.PunchCorrStatus.IN_PROGRESS,
            PunchCorrectionStatusTypes_1.PunchCorrStatus.PENDING,
            PunchCorrectionStatusTypes_1.PunchCorrStatus.FAILED_PENDING_RETRY
        ];
        if (item.status === PunchCorrectionStatusTypes_1.PunchCorrStatus.FAILED &&
            (item.requestType === PunchCorrectionStatusTypes_1.PunchCorrType.MISSED_PUNCH ||
                item.requestType === PunchCorrectionStatusTypes_1.PunchCorrType.EDIT_PUNCH)) {
            return item.reasonCode === PunchCorrectionStatusTypes_1.PunchCorrReason.DUPLICATE;
        }
        return pendingStatus.includes(item.status);
    });
    return [...failedList, ...pendingList, ...successList];
};
